/**
 * Hook que lê a marca global do sistema (logo + nome + cor padrão).
 * Doc: `system_config/branding`. Cache em memória + React Query.
 */
import { useQuery } from '@tanstack/react-query'
import { doc, getDoc } from 'firebase/firestore'
import { db } from '@/config/firebase'

interface SystemBranding {
  logo_url?: string | null
  nome_sistema?: string
  cor_primaria?: string
}

export function useSystemBranding() {
  return useQuery({
    queryKey: ['system_branding'],
    staleTime: 5 * 60 * 1000,  // 5min cache — não muda toda hora
    queryFn: async (): Promise<SystemBranding> => {
      try {
        const snap = await getDoc(doc(db, 'system_config', 'branding'))
        return snap.exists() ? (snap.data() as SystemBranding) : {}
      } catch {
        return {}
      }
    },
  })
}
